const constants = {
  USER: "USER",
  TOKEN: "TOKEN",
};

export default constants;
